import {newAxiosClient} from './axios';
import {getAccessToken} from '../utils/token-manager';

export interface ApiResponse<T> {
  success: boolean;
  message: string;
  data: T;
  error: boolean;
  error_message: string | null;
}

export const postLogin = async (
  email: string,
  password: string
): Promise<ApiResponse<any>> => {
  return await newAxiosClient.post('/auth/employee-login', {
    email,
    password
  });
};

export const getFirebaseCustomToken = async () => {
  return await newAxiosClient.post('/firebase-admin/employee-token');
};

export const postLogout = async (): Promise<any> => {
  return await newAxiosClient.post(
    '/auth/logout',
    {},
    {
      headers: {
        'X-Access-Token': getAccessToken(),
        Authorization: `Bearer ${localStorage.getItem('refreshToken')}`
      }
    }
  );
};

export interface EmployeeDto {
  id: string;
  email: string | null;
  full_name: string | null;
  role: string | null;
  airline_id: string | null;
  status: string;
  created_at: string | null;
  updated_at: string | null;
  deleted_at: string | null;
}

export interface EmployeeLoginData {
  access_token: string;
  refresh_token: string;
  token_type: string;
  expires_in: number;
  employee: EmployeeDto | null;
}

/**
 * POST /auth/employee-forgot-password
 * Backend generates a new temporary password and emails it to the employee.
 */
export const postEmployeeForgotPassword = async (
  email: string
): Promise<ApiResponse<null>> => {
  return await newAxiosClient.post('/auth/employee-forgot-password', {email});
};

/**
 * PATCH /api/v1/internal/employees/password
 * Requires Bearer access token. Updates the current employee's own password.
 */
export const patchEmployeeChangePassword = async (
  oldPassword: string,
  newPassword: string
): Promise<ApiResponse<null>> => {
  return await newAxiosClient.patch(
    '/api/v1/internal/employees/password',
    {
      old_password: oldPassword,
      new_password: newPassword
    }
  );
};
